import { render, staticRenderFns } from "./LightSwitch.vue?vue&type=template&id=c6cf3180&scoped=true&"
import script from "./LightSwitch.vue?vue&type=script&lang=js&"
export * from "./LightSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cf3180",
  null
  
)

export default component.exports